import React from "react";

// CTASection.tsx
// Tailwind + React component to reproduce the exact CTA layout in your screenshot.
// Assets used (place them in your public/assets or update the paths):
// - /assets/google-play-badge.png  (recommended height: 44px)
// - /assets/app-store-badge.png    (recommended height: 44px)
// - /assets/phone-mockup.png       (phone mockup that already contains the QR)

export default function CTASection() {
  return (
    <section className="hidden md:block  px-4 sm:px-6 lg:px-8 mb-4">
      <div className="max-w-7xl mx-auto">
        {/* Card */}
        <div className="relative bg-gradient-to-br from-[#F5EFE7] to-[#E8DCC8] rounded-[36px] pt-6 sm:pt-10 md:pt-12 px-6 sm:px-10 md:px-12 overflow-hidden shadow-[0_18px_40px_rgba(13,12,11,0.06)]">
          {/* subtle decorative shapes behind content (faint curve on right) */}
          <svg
            className="pointer-events-none absolute right-[-8%] top-0 h-full w-[60%] opacity-20"
            viewBox="0 0 800 400"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
          >
            <path
              d="M0 160C70 120 140 100 260 120C380 140 540 200 800 220V400H0V160Z"
              fill="#EDE2D4"
            />
          </svg>

          <div className="relative flex flex-col lg:flex-row items-center gap-8">
            {/* Left */}
            <div className="w-full lg:w-1/2 text-center lg:text-left py-12">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#0F1724] leading-tight">
                Download the app now!
              </h2>

              <p className="mt-3 text-sm sm:text-base text-[#4B5563] max-w-md mx-auto lg:mx-0">
                Experience seamless experience
                <br />
                only with Gallyo app
              </p>

              {/* badges */}
              <div className="mt-6 flex items-center justify-center lg:justify-start gap-3">
                <a
                  href="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Google_Play_Store_badge_EN%201-pC0zVKtBIj1Q7E7WGp1juUFzixpqP4.svg"
                  aria-label="Get it on Google Play"
                  className="inline-block transform transition-transform hover:scale-105"
                >
                  <img
                    src="/assets/google-play-badge.png"
                    alt="Google Play"
                    className="h-11 sm:h-12 md:h-14 object-contain"
                  />
                </a>
                <a
                  href="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/download-on-the-app-store-apple-logo-svgrepo-com%201-IIS3UHJPhxe7pkO2z90baSIKjxO9w7.svg"
                  aria-label="Download on the App Store"
                  className="inline-block transform transition-transform hover:scale-105"
                >
                  <img
                    src="/assets/app-store-badge.png"
                    alt="App Store"
                    className="h-11 sm:h-12 md:h-14 object-contain"
                  />
                </a>
              </div>
            </div>

            {/* Right - phone mockup */}
            <div className="w-full lg:w-1/2 flex justify-center lg:justify-end items-end">
              <div className="relative w-[220px] sm:w-[260px] md:w-[320px] -mb-0">
                {/* phone container (flush with bottom of card) */}
                <div className="relative  overflow-hidden  ">
                  <img
                    src="/assets/phone-mockup.png"
                    alt="Scan the QR code to download the app"
                    className="w-full h-auto block align-bottom"
                    draggable={false}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* thin bottom rounding accent (to better match example) */}
          <div className="absolute bottom-0 left-0 right-0 h-8 bg-[linear-gradient(90deg,#ffffff00,#ffffff18)] rounded-b-[36px] pointer-events-none"></div>
        </div>
      </div>
    </section>
  );
}
